import HeroButton from "@components/HeroButton";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";

import YellowCTAhref from "@components/yellowCTAhref";
import React from "react";
import { RiArrowDropDownLine } from "react-icons/ri";

const NewZapierPage: React.FC = () => {
    const [currIndex, setCurrIndex] = React.useState(0);
    const [dropDownOpen, setDroDownOpen] = React.useState(false);
    const zapierSplContent = [
        {
            logo: "https://assets.gallabox.com/gb-home/new-zapier/cp-logo.svg",
            img: "https://assets.gallabox.com/gb-home/new-zapier/cp-img.svg",
            textWithLogo: [
                {
                    title: "TRIGGER",
                    desc: <span>When lead status updated to Customer</span>,
                },
                {
                    title: "ACTION",
                    desc: (
                        <span>
                            Send payment link in <span className="font-bold">WhatsApp</span>
                        </span>
                    ),
                },
                {
                    title: "ACTION",
                    desc: (
                        <span>
                            Alert me in <span>Slack</span> about payment status
                        </span>
                    ),
                },
            ],
        },
        {
            logo: "https://assets.gallabox.com/gb-home/new-zapier/pl-logo.svg",
            img: "https://assets.gallabox.com/gb-home/new-zapier/pl-img.svg",
            textWithLogo: [
                {
                    title: "TRIGGER",
                    desc: <span>When lead status updated to Customer</span>,
                },
                {
                    title: "ACTION",
                    desc: (
                        <span>
                            Create a new lead record in <span className="font-bold">CRM</span>
                        </span>
                    ),
                },
                {
                    title: "ACTION",
                    desc: <span>Send a welcome message to the new lead</span>,
                },
            ],
        },
        {
            logo: "https://assets.gallabox.com/gb-home/new-zapier/us-logo.svg",
            img: "https://assets.gallabox.com/gb-home/new-zapier/us-img.svg",
            textWithLogo: [
                {
                    title: "TRIGGER",
                    desc: <span>When a lead makes a purchase at my online store</span>,
                },
                {
                    title: "ACTION",
                    desc: <span>Update lead status to Customer</span>,
                },
                {
                    title: "ACTION",
                    desc: <span>Send invoice details to Customer</span>,
                },
            ],
        },
    ];
    const handleBtnSelect = (num: number) => {
        setCurrIndex(num);
        setDroDownOpen(false);
    };
    return (
        <NewLayout
            title="Zapier WhatsApp Integration for Workflows | Gallabox"
            description="Connect WhatsApp to 5,000+ apps with Zapier WhatsApp integration by Gallabox. Automate messages and workflows easily."
            canonical="https://gallabox.com/whatsapp-integrations/zapier"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/new-zapier/zapier-og.png" }}
        >
            <div className="px-5 pale-blue-bg-mobile">
                <header className="md:pt-20 pb-0 md:pb-8 max-w-6xl mx-auto wati">
                    <div className="flex  flex-wrap md:flex-nowrap  justify-center md:justify-between">
                        <div className="md:w-3/6 flex flex-col my-10 wa-mobile-a">
                            <span className="">
                                <p
                                    className="text-green-700 bg-green-200 wati-top-green font-bold flex w-fit m-auto md:m-0"
                                    style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid #099250" }}
                                >
                                    <p>No-code automation for busy people</p>
                                    <img
                                        height={"24px"}
                                        width={"24px"}
                                        loading="lazy"
                                        src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                        alt="white-border-whatsapp-icon"
                                        className="ml-2"
                                    />
                                </p>
                                <h1 className="font-bold mb-0 text-blue-500 md:text-5xl text-2xl text-center md:text-left">
                                    Zapier WhatsApp Integration – Automate Workflows with Zero Effort!
                                </h1>
                                <span className="text-base md:text-xl font-normal block max-w-xl mb-6 my-3 md:my-10 text-center md:text-left" style={{ color: "#444444" }}>
                                    Collect payments, book appointments, send discount alerts, update the lead status.{" "}
                                </span>
                            </span>
                            <HeroButton buttontext="7-day free trial" />
                        </div>
                        <div>
                            <img
                                loading="lazy"
                                src="https://assets.gallabox.com/gb-home/new-zapier/zapier-header.svg"
                                alt="Connect your apps Automate tasks"
                                className="landing-right-banner mx-auto"
                            />
                        </div>
                    </div>
                </header>

                <div className="lg:max-w-7xl mx-auto client-logos pt-2 md:pt-0">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>

                <section className="zapier-spl-cont mt-20 md:mt-32">
                    <h2 className="text-center mx-auto text-2xl md:text-5xl mb-10">
                        Do more with{" "}
                        <span className="relative w-fit inline-block" style={{ zIndex: 2 }}>
                            Zapier Integrations{" "}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ zIndex: -1, bottom: "-24px", right: "0px", position: "absolute" }}
                                width={"100%"}
                                height="37"
                                viewBox="0 0 461 37"
                                fill="none"
                            >
                                <g filter="url(#filter0_d_634_2)">
                                    <path d="M5.6814 8.57812L455.63 6.90732" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                    <path d="M189.977 20.4772L373.926 16.6838L455.569 17.0549" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                </g>
                            </svg>
                            <svg
                                style={{ top: "0px", right: "-29px", position: "absolute" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="22"
                                viewBox="0 0 27 22"
                                fill="none"
                            >
                                <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </span>
                    </h2>
                    <div className="button-cont hidden md:block">
                        <button onClick={() => setCurrIndex(0)} className={`${currIndex == 0 ? "selected-button" : ""}`}>
                            Collect Payments
                        </button>
                        <button onClick={() => setCurrIndex(1)} className={`${currIndex == 1 ? "selected-button" : ""}`}>
                            Push Leads
                        </button>
                        <button onClick={() => setCurrIndex(2)} className={`${currIndex == 2 ? "selected-button" : ""}`}>
                            Update Status
                        </button>
                    </div>
                    <div className="button-cont-mobile block md:hidden relative">
                        <div onClick={() => setDroDownOpen((prev) => !prev)} className="selected-button flex gap-x-5 justify-center items-center relative z-4">
                            <span>{currIndex == 0 ? "Collect Payments" : currIndex == 1 ? "Push Leads" : "Update Status"}</span>

                            <RiArrowDropDownLine fontSize={"34px"} />
                        </div>
                        {dropDownOpen && (
                            <div className="flex drop-down-content flex-col pt-4">
                                <button className="py-5 px-3" onClick={() => handleBtnSelect(0)}>
                                    Collect Payments
                                </button>
                                <button className="py-5 px-3" onClick={() => handleBtnSelect(1)}>
                                    Push Leads
                                </button>
                                <button className="py-5 px-3" onClick={() => handleBtnSelect(2)}>
                                    Update Status
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="zapier-spl-img-cont">
                        <div className="zapier-logo-cont">
                            <div className="text-gray-700 flex flex-nowrap items-center text-xs">
                                <img loading="lazy" src={zapierSplContent[currIndex]?.logo} alt="" />
                                <div className="flex flex-col flex-nowrap" style={{ gap: "60px" }}>
                                    {zapierSplContent[currIndex]?.textWithLogo?.map((data, ind) => (
                                        <p key={data.title + ind}>
                                            <span className="block font-bold">{data?.title}</span>
                                            {data?.desc}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="zapier-img-cont">
                            <img loading="lazy" className="mt-8" src={zapierSplContent[currIndex]?.img} alt="" />
                        </div>
                    </div>
                </section>

                <section className="mt-28 md:mt-36">
                    <h2 className="text-center mx-auto text-2xl md:text-5xl">
                        <span className="relative w-fit inline-block" style={{ zIndex: 2 }}>
                            Testimonials{" "}
                            <svg
                                className="absolute right-0"
                                style={{ zIndex: -1, bottom: "-25px", right: "0px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="100%"
                                height="39"
                                viewBox="0 0 290 39"
                                fill="none"
                            >
                                <path d="M1.13689 12.9043L288.611 4.06572" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                <path d="M119.139 21.865L236.602 15.142L288.777 14.2123" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            <svg
                                style={{ top: "0px", right: "-29px", position: "absolute" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="27"
                                height="22"
                                viewBox="0 0 27 22"
                                fill="none"
                            >
                                <path d="M1.60547 16.4111L9.4314 3.36792" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                <path d="M8.12695 20.8459L15.692 19.2808" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                                <path d="M4.47461 18.7598L25.6046 1.54272" stroke="#55CD6C" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </span>
                    </h2>
                    <div className="mt-14">
                        <div className="wati-testimonial-blk text-center md:text-left m-auto">
                            <a href="https://www.g2.com/products/gallabox/reviews/gallabox-review-7643564" rel="noreferrer" target="_blank">
                                <img
                                    alt="g2logo"
                                    src="https://assets.gallabox.com/gb-home/new-wati/orange-logo.svg"
                                    style={{ position: "absolute", right: "10px", top: "10px" }}
                                    className="hidden md:block"
                                />
                            </a>
                            <div>
                                <div className="testi-star flex justify-center md:justify-start">
                                    {["full", "full", "full", "full", "full"].map((star, i) => (
                                        <img
                                            alt={`${star === "full" ? "full star" : `${star} filled star`}`}
                                            loading="lazy"
                                            key={i + "star"}
                                            src={`https://assets.gallabox.com/gb-home/new-wati/${star}-star.svg`}
                                        />
                                    ))}
                                </div>
                                <p className="text-2xl font-bold my-5 px-10 md:px-0 md:mt-2.5 md:mb-0">&quot;Great overall service&quot;</p>
                                <p className="text-gray-500 text-base md:text-lg font-normal px-10 md:px-0 my-2.5">What do you like best about Gallabox?</p>
                                <p className="text-gray-700 text-sm md:text-lg font-normal px-9 md:px-0">
                                    <div className="flex flex-col gap-y-8">
                                        <p>
                                            - The interface is very <span className="font-bold md:font-normal block md:inline">user-friendly.</span>
                                        </p>
                                        <p>
                                            - Integrations are <span className="font-bold md:font-normal block md:inline">working flawlessly.</span>
                                        </p>
                                        <p>
                                            - The mobile app is also straightforward to use and <span className="font-bold md:font-normal block md:inline">very user-friendly</span>
                                        </p>
                                        <p>
                                            - <span className="font-bold md:font-normal block md:inline">Great customer support.</span> Very patient and helpful.
                                        </p>
                                    </div>
                                </p>
                                <div>
                                    <div className="text-gray-700 mt-5 md:mt-6">
                                        <p className="font-bold text-xl md:text-2xl">Achin T. </p>
                                        <span className="font-normal text-xs text-lg"> Co-Founder- Aantrik</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="px-5" style={{ background: "linear-gradient(180deg, rgba(246,251,255,1) 95%, rgba(255,255,255,1) 100%)" }}>
                <section className="pt-36 bg-white md:pb-26 pb-40">
                    <YellowCTAhref
                        customText="Integrate your workflow with 5000+ apps"
                        // link2="https://calendly.com/gallabox/get-personalized-walktrhough?utm_source=website&utm_medium=zapier&utm_campaign=lp"
                    />
                </section>
            </div>
        </NewLayout>
    );
};

export default NewZapierPage;
